import styled from 'styled-components';
import mainColors from '../../../../Style-guide/main-colors';
import sizeStandards from '../../../../Style-guide/size-standards';

const ScheduleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  max-width: 360px;

  .schedule-title {
    align-self: center;
    margin-bottom: 20px;
  }

  .day-title {
    margin-left: 8px;
  }

  @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
    .day-title {
      font-size: ${sizeStandards.font.SM}px;
    }
  }
  @media only screen and (max-width: ${sizeStandards.screen.XS}px) {
    .day-title {
      font-size: ${sizeStandards.font.XS - 2}px;
    }
  }

  .non-working {
    color: ${mainColors.addOpacityTo(mainColors.text_color, 0.4)};
    user-select: none;

    .time-input {
      color: ${mainColors.addOpacityTo(mainColors.text_color, 0.4)};
    }
  }

  .day-row {
    margin: 8px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;

    .time-input-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;

      .time-input {
        /* max-width: 80px; */
        max-width: 100%;
        max-height: 24px;
        margin: 0 4px;

        @media only screen and (max-width: ${sizeStandards.screen.XL}px) {
          font-size: ${sizeStandards.font.XS - 2}px;
        }
        @media only screen and (max-width: ${sizeStandards.screen.XS}px) {
          font-size: ${sizeStandards.font.XS - 3}px;
        }
      }
    }

    .day-switcher {
      bottom: 4px;
    }
  }
`;

export default ScheduleWrapper;
